import { createStyles } from '@mantine/core';

type UseStylesProps = {
  isMobile: boolean;
  iconBackground?: string;
};
const useStyles = createStyles((theme, { isMobile, iconBackground }: UseStylesProps) => ({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: isMobile ? theme.spacing.sm : theme.spacing.md,
    padding: theme.spacing.xs,
    textAlign: 'center',
  },
  iconWrapper: {
    width: 64,
    height: 64,
    borderRadius: '100em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: iconBackground ?? theme.white,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.xs,
  },
}));

export default useStyles;
